<template>
  <div class="widget-custom-in news-component">
    <Swiper
      @swiper="onSwiper"
      @slideChange="onSlideChange"
      :slidesPerView="1"
      :spaceBetween="25"
      :allowTouchMove="false"
      :navigation="{
        prevEl: prevEl,
        nextEl: nextEl,
      }"
      :modules="modules"
    >
      <SwiperSlide class="news-component__item" v-for="news in newses" :key="news.id">
        <img v-if="news.previewPicture" class="news-component__img" :src="news.previewPicture" alt="Фото новости" />
        <h3 class="news-component__title">
          {{ news.name }}
        </h3>
        <p class="news-component__date">
          {{ $momentFormat(news.activeFrom, Constants.DATE_FORMATS.DD_MMMM_YYYY) }}
        </p>
        <p class="news-component__about">
          {{ news.previewText }}
        </p>
      </SwiperSlide>

      <!-- Кастомные кнопки навигации -->
      <button class="widget2-custom-prev" ref="prevEl" :class="{ disabled: isBeginning }">
        <IconComponent name="arrow_back" />
      </button>
      <button class="widget2-custom-next" name="arrow_back" ref="nextEl" :class="{ disabled: isEnd }">
        <IconComponent name="arrow_back" />
      </button>
    </Swiper>

    <div class="news-component__footer">
      <ButtonComponent mod="gradient-bg" @click="goTo">Перейти</ButtonComponent>
    </div>
  </div>
</template>

<script>
  import { Navigation } from 'swiper/modules';
  import { Swiper, SwiperSlide } from 'swiper/swiper-vue';
  import 'swiper/swiper-bundle.css';

  import ButtonComponent from '@/common/components/redesigned/ButtonComponent.vue';
  import Constants from '@/common/constants';
  import IconComponent from '@/common/ui/IconComponent.vue';

  import API from '../api/widgetElement';

  export default {
    name: 'Widget2',
    components: {
      Swiper,
      SwiperSlide,
      IconComponent,
      ButtonComponent,
    },
    props: {
      countryId: {
        type: Number,
        default: null,
      },
    },
    watch: {
      countryId: function (/*newValue*/) {
        this.loadNews();
      },
    },
    data() {
      return {
        newses: [],
        prevEl: null,
        nextEl: null,
        swiper: null,
        isBeginning: true,
        isEnd: false,
        Constants: Constants,
      };
    },
    created() {
      this.loadNews();
    },
    mounted() {
      this.prevEl = this.$refs.prevEl;
      this.nextEl = this.$refs.nextEl;
    },
    methods: {
      loadNews() {
        API.getNews({ countryId: this.countryId }).then((response) => {
          this.newses = response.data;
          this.$nextTick(() => {
            if (this.swiper) {
              this.updateButtonStates();
            }
          });
        });
      },
      onSwiper(swiper) {
        this.swiper = swiper;
        window.swiper = swiper;
        this.updateButtonStates();
      },
      onSlideChange() {
        this.updateButtonStates();
      },
      updateButtonStates() {
        if (this.swiper) {
          this.isBeginning = this.swiper.isBeginning;
          this.isEnd = this.swiper.isEnd;
        }
      },
      goTo() {
        this.$router.push('Media');
      },
    },
    computed: {
      modules() {
        return [Navigation];
      },
    },
  };
</script>

<style lang="scss">
  // News
  @import '../../../assets/theme/default/colors.scss';

  .news-component {
    position: relative;

    &__img {
      width: 100%;
      height: 233px;
      object-fit: cover;
      margin-bottom: 20px;
    }
    &__title {
      font-weight: 700;
      font-size: 16px;
      line-height: 150%;
      text-transform: uppercase;
      color: $black;
      margin-bottom: 10px;
    }
    &__date {
      font-weight: 400;
      font-size: 14px;
      line-height: 23px;
      color: #343c44;
      margin-bottom: 10px;
    }
    &__about {
      font-weight: 400;
      font-size: 14px;
      line-height: 150%;
      color: $black;
      margin-bottom: 0px;
    }
    &__footer {
      position: fixed;
      bottom: 0;
      left: 0;
      right: 0;
      padding: 2rem;
      width: 100%;
      display: flex;
      justify-content: flex-end;
    }
  }
  .swiper {
    width: 100%;
    position: relative;
  }

  .widget2-custom-prev,
  .widget2-custom-next {
    position: absolute;
    top: 25%;
    width: 30px;
    height: 30px;
    display: flex;
    opacity: 1;
    color: $white;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    z-index: 10;
    background: $colorGradient;
    border: none;
    outline: none;
    border-radius: 4px;

    &:hover {
      background: $colorGradient2;
    }

    svg {
      width: 17px;
      height: 14px;
    }

    &.disabled {
      opacity: 0.5;
      cursor: default;
      svg {
        cursor: default;
      }
      &:hover {
        background: $colorGradient;
      }
    }
  }

  .widget2-custom-prev {
    left: 0px;
  }

  .widget2-custom-next {
    right: 0px;
    transform: rotate(180deg);
  }

  @media (max-width: 425px) {
    .news-component__about {
      /* 3 точие */
      overflow: hidden;
      text-overflow: ellipsis;
      display: -moz-box;
      -moz-box-orient: vertical;
      display: -webkit-box;
      -webkit-line-clamp: 7;
      -webkit-box-orient: vertical;
      line-clamp: 7;
      box-orient: vertical;
    }

    .widget2-custom-prev,
    .widget2-custom-next {
      width: 30px;
      height: 30px;

      svg {
        width: 14px;
        height: 12px;
      }
    }
  }
</style>

<style lang="scss" scoped>
  .news-component__item {
    padding: 0px 36px;
  }
</style>
